<template>
    <v-card class="rules-item">
        <v-btn class="rules-item__close-icon"
               @click="closeItem"
               absolute
               x-small
               fab
               top
               right
               color="secondary">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="rules-item__row">
            <div class="rules-item__label">
                <div class="title__icon-container">
                    <v-img :src="require(`@/assets/img/icons/people--white.svg`)" class="title__icon">
                    </v-img>
                </div>
                <p class="rules-item__title">People</p>
            </div>
            <div class="rules-item__select">
                <v-select
                        v-model="form.input.type"
                        :items="filterOptions"
                        label="Select rule"
                        :append-icon="'mdi-chevron-down'">
                    <template v-slot:selection="{ item }">
                        <span class="custom-value">
                            {{item.text}}
                        </span>
                    </template>
                </v-select>
            </div>
        </div>
        <RuleValue
                v-model="form.input.value" :autocomplete="userAutoComplete">
        </RuleValue>
    </v-card>
</template>

<script>
    import RuleValue from "./RuleValue";
    import {store} from "../../../store/store";
    import axios from "axios";

    export default {
        name: "People",
        components: {RuleValue},
        props: ['value', 'uid'],
        data: () => ({
            form: {
                input:
                    {
                        value: null,
                        type: null
                    },
                type: "People",
            },
            filterOptions: [{
                text: 'following',
                value: 'is-following',
            }, {
                text: 'not following',
                value: 'is-not-following',
            }, {
                text: 'followed by',
                value: 'is-followed-by',
            }, {
                text: 'not followed by',
                value: 'is-not-followed-by',
            }],
        }),
        mounted() {
            // console.log("People mounted", JSON.parse(JSON.stringify(this.value)))

            if (this.value) {
                this.form = this.value;
            }
        },
        methods: {
            closeItem: function () {
                this.$emit('itemClosed', this.uid)
            },
            userAutoComplete (name) {
                const token = store.state.accessToken;
                return axios.get("/community/options/friends",
                                 {headers: {"Authorization": "Bearer " + token,
                                            "Content-type": "application/json"},
                                  params: {s: name}})
                    .then(resp => resp.data)
            }
        },
        watch: {
            form: {
                handler: function (val, oldVal) {
                    // console.log("People form change", JSON.parse(JSON.stringify(this.value)))
                    if (val.input.type) {
                        this.$emit('input', val)
                    }
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    // console.log("People value change", JSON.parse(JSON.stringify(this.value)))
                    if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
                        this.form = val
                    }
                },
                deep: true
            }
        }
    };
</script>

<style scoped>

</style>
